webpackJsonp([119139116539234],{

/***/ 1736:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"CustomClientField","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"insertedAt","type":{"kind":"SCALAR","name":"NaiveDateTime","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"isActive","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"type","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":"A custom client information field","enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-custom-client-field-c1824fea9cec29fbe959.js